export { default } from './MessageBubbleCenterOutline'
